import React from 'react';

import styled from 'styled-components';

import SelectAdvancedFilterRadio from 'components/lib/SelectAdvancedFilterRadio';

import { SHOP_REQUEST_COLUMNS, SHOP_REQUEST_VIEW_FILTER_OPTIONS, SHOP_REQUEST_VIEW_GROUP_BY } from '../constants';
import { useShopRequestsDataContext } from '../ShopRequestsDataContext';

const StyledFilter = styled(SelectAdvancedFilterRadio)`
  margin-right: 5px;
`;

const ShopRequestGroupByFilter = () => {
  const { filters, setFilters, setOrdering } = useShopRequestsDataContext();

  return (
    <StyledFilter
      options={SHOP_REQUEST_VIEW_FILTER_OPTIONS}
      defaultValue={filters.groupBy}
      onSelect={(newValue: number) => {
        if (filters) {
          setFilters({ ...filters, page: 1, groupBy: newValue });
          setOrdering(
            newValue === SHOP_REQUEST_VIEW_GROUP_BY.NONE
              ? SHOP_REQUEST_COLUMNS.dueDate.id
              : SHOP_REQUEST_COLUMNS.requestGroup.id
          );
        }
      }}
      placeholder="View"
      dataTestId="sr-filter-view"
    />
  );
};

export default ShopRequestGroupByFilter;
